import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageComponent } from './message.component';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(public snackBar: MatSnackBar) {}

  public openSnackBar(message: string, panelClass: string) {
    const snackClass = this.getSnackClass(panelClass);

    this.snackBar.openFromComponent(MessageComponent, {
      data: message,
      panelClass: snackClass,
      duration: 10000,
      verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
      horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
    });
  }

  private getSnackClass(panelClass: string): string[] {
    if (!panelClass) {
      return ['snack-info'];
    }

    const normalized = panelClass.trim().toLowerCase();

    if (normalized === 'success') {
      return ['success-snack'];
    }

    if (
      normalized === 'error' ||
      normalized === 'danger' ||
      normalized === 'failed' ||
      normalized === 'failure'
    ) {
      return ['error-snack'];
    }

    if (normalized === 'warning') {
      return ['warning-snack'];
    }

    return ['snack-info'];
  }
}
